import PiInputfield from "../../../components/PiInputField";
import Interaction from "../../../models/interactions/Interaction";
import { ISubSequence } from "../../../models/interactions/SubSequence";
import NodeToggle from "../components/NodeToggle";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function SubSequenceNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as ISubSequence;
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <PiInputfield
        placeholder="Name"
        label="Name"
        value={interaction.sequenceName}
        onChange={(newName) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            sequenceName: newName,
          } as ISubSequence)
        }
      />
      <NodeToggle
        label="Finish All"
        value={interaction.finishAll}
        onChange={(finishAll) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            finishAll,
          } as ISubSequence)
        }
      />
      <NodeToggle
        label="Abort Others on Finish"
        value={interaction.abortOthersOnFinish}
        onChange={(abortOthersOnFinish) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            abortOthersOnFinish,
          } as ISubSequence)
        }
      />
    </div>
  );
}
